<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
    export default {

        created() {
            // Disable the mouse right click event
            window.document.oncontextmenu = function() {
                return false;
            };
        }

    };
</script>

<style>
    #app {
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    #nav {
      padding: 30px;
    }

    #nav a {
      font-weight: bold;
      color: #2c3e50;
    }

    #nav a.router-link-exact-active {
      color: #42b983;
    }
</style>
